import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-baa42098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4" }
const _hoisted_2 = ["aria-label", "onClick"]
const _hoisted_3 = { class: "dashboard-stat-card__label" }
const _hoisted_4 = { class: "dashboard-stat-card__hint" }

import { computed } from "vue";
import { useDashboardMain } from "@/composables/useDashboardMain";
import { t } from "@/i18n";
import type { DashboardDetailType } from "@/types/dashboard/DashboardTypes";


export default /*#__PURE__*/_defineComponent({
  emits: ["open-details"],
  setup(__props, { emit }: { emit: ({
  (event: "open-details", type: DashboardDetailType, title: string): void;
}), expose: any, slots: any, attrs: any }) {



const { counters } = useDashboardMain();

const cards = computed<
  Array<{
    key: string;
    detailType: DashboardDetailType;
    label: string;
    value: number;
    colorClass: string;
  }>
>(() => [
  {
    key: "total",
    detailType: "TOTAL",
    label: t("dashboard.stats.total"),
    value: counters.value?.totalDocuments ?? 0,
    colorClass: "text-gray-900",
  },
  {
    key: "inProgress",
    detailType: "IN_PROGRESS",
    label: t("dashboard.stats.inProgress"),
    value: counters.value?.inProgressDocuments ?? 0,
    colorClass: "text-blue-600",
  },
  {
    key: "signed",
    detailType: "SIGNED",
    label: t("dashboard.stats.signed"),
    value: counters.value?.signedDocuments ?? 0,
    colorClass: "text-green-600",
  },
  {
    key: "rework",
    detailType: "REWORK",
    label: t("dashboard.stats.rework"),
    value: counters.value?.reworkDocuments ?? 0,
    colorClass: "text-orange-500",
  },
  {
    key: "denied",
    detailType: "DENIED",
    label: t("dashboard.stats.denied"),
    value: counters.value?.deniedDocuments ?? 0,
    colorClass: "text-red-500",
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), (card) => {
      return (_openBlock(), _createElementBlock("button", {
        key: card.key,
        type: "button",
        class: "dashboard-stat-card",
        "aria-label": `${_ctx.$t('dashboard.details.openList')}: ${card.label}`,
        onClick: ($event: any) => (emit('open-details', card.detailType, card.label))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(["dashboard-stat-card__value", card.colorClass])
        }, _toDisplayString(card.value), 3),
        _createElementVNode("p", _hoisted_3, _toDisplayString(card.label), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("dashboard.details.viewDocuments")), 1)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})